const clear = {
  type: "svg",
  props: {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  },
  metadata: {
    description: "Indicates terminating action of a window or process.",
    usage: "",
    category: "Navigation",
    tags: ["close"]
  },
  children: [{
    type: "path",
    props: {
      d: "M11.4 13.06l4.596 4.597a.749.749 0 1 0 1.06-1.06l-4.595-4.597 4.596-4.596a.749.749 0 1 0-1.06-1.06l-4.597 4.595-4.596-4.596a.749.749 0 1 0-1.06 1.06l4.595 4.597-4.596 4.596a.749.749 0 1 0 1.06 1.06l4.597-4.595z"
    }
  }]
};
export default clear;